<template>
    <section>
        <div class="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mt-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <InformationCircleIcon
                        class="h-5 w-5 text-blue-400"
                        aria-hidden="true"
                    />
                </div>
                <div class="ml-3">
                    <p class="text-sm text-blue-700" v-html="message"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { InformationCircleIcon } from "@heroicons/vue/solid";

export default {
    components: {
        InformationCircleIcon,
    },
    mounted() {},
    created() {},
    props: ["message"],
    data() {
        return {};
    },
};
</script>
